<template>
  <basicContainer>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               @tree-load="treeLoad"
               ref="crud"
               v-model="form"
               @search-change="searchChange"
               @search-reset="searchReset"
               :before-open="beforeOpen"
               @row-del="rowDel"
               @row-update="rowUpdate"
               @row-save="rowSave"
                @selection-change="selectionChange"
               >
     <template v-slot:subjectStatus="{row,label}" >
       <el-tag v-if="label === '可用'" type="success" size="small" >可用</el-tag>
       <el-tag v-else-if="label === '停用'" type="info" size="small">停用</el-tag>
       <el-tag v-else type="danger" size="small">未知</el-tag>
    </template>
     <template v-slot:subjectType="{row,label}" >
       <el-tag  type="success" size="small" >{{label}}</el-tag>
    </template>
    <!-- 操作按钮扩展 -->
      <template slot="menuLeft">
        <el-button  type="primary" size="small"  icon="el-icon-circle-plus"  @click="concatChildrenPrivate"   >  关联角色 </el-button>
      </template>
    </avue-crud>
      <!-- Concat private theme -->
     <concatPrivate ref="concatPrivate" :isShow="concatTheme.concatPrivateShow" :optionRow="concatTheme.optionRow" :type="concatTheme.type"></concatPrivate>
  </basicContainer>
</template>

<script>

const concatPrivate = () => import('./concatPrivate')

export default {
  components: {
    concatPrivate
  },
  data() {
    return {
      pageControl: {
        subjectType: 'RESOURCE_GROUP'
      },
      loading: false,
      form: {},
      query: {},
      selectionList: [],
      option: {
        height: 610,
        lazy: true,
        rowKey: 'treeId',
        refreshBtn: false,
        searchBtn: false,
        columnBtn: false,
        tip: false,
        tree: true,
        border: false,
        selection: true,
        menu: false,
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        editBtn: false,
        searchMenuSpan: 6,
        column: [
          {
            prop: 'appKey',
            label: '所属应用',
            search: true,
            hide: true,
            type: 'select',
            span: 12,
            dicData: [],
            rules: [{
              required: true,
              message: '请选择所属应用',
              trigger: 'blur'
            }]
          },
          {
            label: '权限名称',
            prop: 'subjectName',
            search: true,
            overHidden: true,
            rules: [{
              required: true,
              message: '请输入权限名称',
              trigger: 'blur'
            }]
          },
          {
            label: '权限标识',
            prop: 'unifiedId',
            search: true,
            rules: [{
              required: true,
              message: '请输入权限标识',
              trigger: 'blur'
            }]
          },
          {
            label: '状态',
            prop: 'subjectStatus',
            type: 'select',
            width: '150px',
            search: true,
            slot: true,
            align: 'center',
            dicData: [
              {
                label: '可用',
                value: 1
              },
              {
                label: '停用',
                value: 2
              }
            ],
            rules: [{
              required: true,
              message: '请选择机构状态',
              trigger: 'blur'
            }]
          }, {
            prop: 'subjectType',
            label: '类型',
            addDisplay: false,
            viewDisplay: false,
            editDisplay: false,
            slot: true,
            width: '150px',
            dicData: [{
              'label': '资源组',
              'value': 'RESOURCE_GROUP'
            }, {
              'label': '机构',
              'value': 'ORG'
            }, {
              'label': '角色',
              'value': 'ROLE'
            }, {
              'label': '用户',
              'value': 'USER'
            }, {
              'label': '其他',
              'value': 'OTHER'
            }]
          }
        ]
      },
      concatTheme: {
        optionRow: {},
        type: '',
        concatResourceShow: { show: false },
        concatPrivateShow: { show: false },
        concatAppShow: { show: false },
        concatPublicShow: { show: false }
      },
      data: [],
      tempCache: null,
      props: {
        lazy: true,
        multiple: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          let parentPermissionSubjectId = node.data && node.data.permissionSubjectId ? node.data.permissionSubjectId : ''
          /** 获取字典  */
          this.$http.post('/org/list', { entity: {
            parentPermissionSubjectId
          }}).then(response => {
            if (response.data.length === 0) {
              node.data.leaf = true
              resolve([])
            } else {
              resolve(response.data.map(item => ({ leaf: false, label: item.name, value: item.id, permissionSubjectId: item.permissionSubjectId })))
            }
          }).catch(error => {
            resolve([])
            this.$message.error('加载上级机构字典错误:' + error)
          })
        }
      }
    }
  },
  created() {
    /** 这里执行其他操作 */
    this.getSelectOPtion()
  },
  methods: {

    selectionChange(list) {
      this.selectionList = list
    },
    /** 搜索重置 */
    searchReset() {
      this.query = {}
    },
    /** 点击搜索 */
    searchChange(params, done) {
      if (!params.appKey) {
        this.$message.error('您必须选择一个所属应用后再进行查询。')
        typeof done === 'function' && done()
      } else {
        this.query = params
        if (params.unifiedId || params.subjectStatus || params.subjectName) {
          this.searchTable(done)
        } else {
          this.loadTable(params, done)
        }
      }
    },
    /** 加载所属应用 */
    getSelectOPtion() {
      this.$http.post('/resource/list-authorized-resource', { entity: {
        'pid': 'Permission.App',
        'appKey': '@PUBLIC'
      }}, { params: { action: 'READ' }}).then(response => {
        let result = response.data.map(element => {
          let temp = {}
          element.resourceExtList.forEach(item => {
            if (item.extPropertyKey === 'appName') {
              temp.label = item.extPropertyValue
            } else if (item.extPropertyKey === 'appKey') {
              temp.value = item.extPropertyValue
            }
          })
          return temp
        })
        if (result.length !== 0) {
          this.option.column[this.findArray(this.option.column, 'appKey', 'prop')].dicData = result
          try {
            this.$refs.crud.searchForm.appKey = this.query.appKey = result[0].value
            this.searchChange(this.query)
            /** 加载第一层资源 */
          } catch (e) {
            this.$message.error('默认填充appKey失败。')
          }
        }
      }).catch(error => {
        this.$message.error(error.msg)
      })
    },
    searchTable: function(done) {
      /** 下级节点 */
      this.loading = true
      this.$http.post('/permission/subject/private/common/list', {
        entity: {
          appKey: this.query.appKey,
          subjectType: this.pageControl.subjectType,
          subjectName: this.query.subjectName ? this.query.subjectName : null,
          unifiedId: this.query.unifiedId ? this.query.unifiedId : null,
          subjectStatus: this.query.subjectStatus ? this.query.subjectStatus : null
        }
      }, { params: {
        searchType: 'NOT_APP'
      }}).then(response => {
        typeof done === 'function' && done()
        this.loading = false
        this.data = response.data
      }).catch(error => {
        typeof done === 'function' && done()
        this.data = []
        this.loading = false
        this.$message.error(error.msg)
      })
    },
    loadTable(params = this.query, done) {
      this.loading = true
      this.$http.post('/permission/subject/top-subject', undefined, {
        params: {
          appKey: params.appKey,
          'subjectTypeEnum': this.pageControl.subjectType
        }
      }).then(response => {
        this.loading = false
        typeof done === 'function' && done()
        this.data = response.data.map(element => {
          element.hasChildren = true
          element.treeId = element.id
          return element
        })
      }).catch(error => {
        typeof done === 'function' && done()
        this.loading = false
        this.$message.error(error.msg)
      })
    },
    treeLoad(tree, treeNode, resolve) {
      /** 下级节点 */
      this.$http.post('/permission/subject/private/common/list', {
        entity: {
          appKey: this.query.appKey,
          'subjectType': this.pageControl.subjectType
        }
      }, { params: {
        searchType: 'NOT_APP',
        parentSubjectIdList: tree.id,
        unionParentSubjectType: 'IN'
      }}).then(response => {
        treeNode.childNodes = []
        return resolve(response.data.map(element => {
          element.hasChildren = true
          element.treeId = tree.id + element.id
          return element
        }))
      }).catch(error => {
        treeNode.childNodes = []
        resolve([])
        this.$message.error(error.msg)
      })
    },
    rowSave(row, loading, done) {
      row.subjectType = this.pageControl.subjectType
      this.$http.post('/permission/subject/private/common', [row]).then(response => {
        this.searchChange(this.query)
        this.$message.success('操作成功！') && loading()
      }).catch(error => {
        this.$message.error(error.msg) && done()
      })
    },
    rowUpdate(row, index, loading, done) {
      row.subjectType = this.pageControl.subjectType
      this.$http.put('/permission/subject/private/common', [row]).then(response => {
        this.searchChange(this.query)
        this.$message.success('操作成功！') && loading()
      }).catch(error => {
        this.$message.error(error.msg) && done()
      })
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        this.loading = true
        this.$http.post('/permission/subject/private/common/delete', [{ 'id': row.id, 'appKey': row.appKey }]).then(response => {
          this.loading = false
          this.searchChange(this.query)
          this.$message.success('删除私有主题成功！')
        }).catch(error => {
          this.loading = false
          this.$message.error(error.msg)
        })
      })
    }, /** 弹出打开之前 */
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        this.loading = true
        this.$http.get('/permission/subject/private/common/' + this.form.appKey + '/' + this.form.id).then(response => {
          this.loading = false
          done()
          this.form.subjectExtList = response.data.subjectExtList
        }).catch(error => {
          this.loading = false
          this.$message.error(error.msg)
        })
      } else {
        done()
      }
    },
    searchFirst: function(params = this.query, done) {
      this.$http.post('/org/list', {
        entity: params
      }).then(response => {
        this.loading = false
        this.data = response.data
        typeof done === 'function' && done()
      }).catch(error => {
        this.loading = false
        this.data = []
        this.$message.error('搜索失败:' + error.msg)
        typeof done === 'function' && done()
      })
    },
    loadFirst: function() {
      this.loading = true
      this.$http.post('/org/list', {
        entity: { 'parentPermissionSubjectId': '' }
      }).then(response => {
        this.loading = false
        this.data = response.data.map(element => {
          element.hasChildren = true
          return element
        })
      }).catch(error => {
        this.loading = false
        this.$message.error('根节点加载失败:' + error.msg)
      })
    },

    /** 关联资源相关操作 */
    /** Set children private theme */
    concatChildrenPrivate: function() {
      this.concatTheme.type = 'down'
      this.concatInitialize('concatPrivate')
    },
    /** Popover initialization */
    concatInitialize: function(obj) {
      if (this.selectionList.length === 0) {
        return this.$message.warning('请选中一条记录再操作哟。')
      } else if (this.selectionList.length >= 2) {
        return this.$message.warning('只能选择一行记录进行操作哟')
      }

      this.concatTheme.optionRow = this.deepClone(this.selectionList[0])
      /** need to initialize the popover before it opens */
      this.$refs[obj].Initialize()
      this.concatTheme[obj + 'Show']['show'] = true
    }

  }
}
</script>

<style>
</style>
